import { render, staticRenderFns } from "./DeviceAirpure.vue?vue&type=template&id=1d8db9c2&scoped=true&"
import script from "./DeviceAirpure.vue?vue&type=script&lang=js&"
export * from "./DeviceAirpure.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAirpure.vue?vue&type=style&index=0&id=1d8db9c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8db9c2",
  null
  
)

export default component.exports